var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-router-view"},[_c('transition',{attrs:{"name":"custom-classes-transition","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }